import { render, staticRenderFns } from "./SignWaiver.vue?vue&type=template&id=26ef2acf&scoped=true"
import script from "./SignWaiver.vue?vue&type=script&lang=ts"
export * from "./SignWaiver.vue?vue&type=script&lang=ts"
import style0 from "./SignWaiver.vue?vue&type=style&index=0&id=26ef2acf&prod&lang=scss"
import style1 from "./SignWaiver.vue?vue&type=style&index=1&id=26ef2acf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ef2acf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VTextField})
